import PubSub from "pubsub-js";
import Component from "../../shared/component.abstract";
import {isEventOn} from "../../shared/helpers/html-utils"
import { getSingleInstanceByElement } from "../../core";
import GlobalEvent from "../trackers/global-event";
import { onDisplay } from "../helpers/support";

interface Throttle {
  delay: number,
  timeout?: any,
  last?: Date | boolean
}
interface EventTrack {
    [index:string]:any,
    event?: string,
    trigger: string,
    ecommerce: Ecommerce,
    totalCount?: string,
    types : string[],
    autoSearch?: boolean,
    totalUngroupCount?: any,
    searchQuoi?:string,
    searchOu?:string,
    searchRayon?:string
}

interface Ecommerce {
    currencyCode: string,
    impressions: any[]
}

class DataForClickBundle {
   displayed:any[] = [];
   tracked:any[] = [];
   waiting:any[] = [];
   tracking = false;
   _singleton: any;
   throttle: Throttle
  
    constructor(){
      this.throttle = {
          delay : 150,
      }
    }

    _getInstance() {
        DataForClickBundle.prototype._singleton = DataForClickBundle.prototype._singleton || new DataForClickBundle();
        return DataForClickBundle.prototype._singleton;
    }

    _register(dataForClick:DataForClick):void{
         const singleton = DataForClickBundle.prototype._getInstance();
         PubSub.subscribe("dataforclick-displayed", (msg:string,instance:any) => {
            if (
              !instance.alreadyDisplayed &&
              singleton.displayed.indexOf(instance) < 0 &&
              singleton.tracked.indexOf(instance)
            ) {
              if (singleton.tracking) {
                singleton.waiting.push(instance);
              } else {
                singleton.displayed.push(instance);
                singleton.waitTrack();
                instance.alreadyDisplayed = true;
              }

            }
        });
    }

    waitTrack() {
        if (this.throttle.timeout) {
          clearTimeout(this.throttle.timeout);
          this.throttle.timeout = undefined;
        }
        const now = new Date();
        const throttled =
          this.throttle.last &&
          now.getTime() - (<Date>this.throttle.last).getTime() > this.throttle.delay;
        if (!this.throttle.last) {
          this.throttle.last = now;
        }
        if (throttled) {
          this.throttle.last = now;
          this.throttle.last = false;
          this.trackDisplay();
        } else {
          this.throttle.timeout = setTimeout(()=> {
            this.waitTrack();
          }, this.throttle.delay);
        }
    }

    trackDisplay() {
        this.tracking = true;
        if (this.displayed.length) {
            const ev:EventTrack = {
                trigger : "init",
                types : ["gtm"],
                ecommerce:{
                    currencyCode : "EUR",
                    impressions : []
                },
            };
            // impressionLoad doesn't need to contains page informations
            ev.event = "impressionLoad";
            const fors = [];
            for (let i = 0; i < this.displayed.length; i++) {
                if (this.displayed[i].linked && this.displayed[i].linked.hasAttribute("data-click")) {
                    fors.push(this.displayed[i]);
                }
            }
            for (let i = 0; i < fors.length; i++) {
                const elt = JSON.parse(fors[i].linked.getAttribute("data-click"));
                if (!elt.list) {
                    elt.list = "LO-Moteur";        
                    const faceting = document.querySelectorAll("[data-engine-facets]").length;
                    if (faceting) {
                        if (elt.exclu && ((elt.exclu + "") == "True" || (elt.exclu + "") == "true")) {
                            elt.list += "-Exclusif";
                        } else if (elt.orange && ((elt.orange + "") == "True" || (elt.orange + "") == "true")) {
                            elt.list += "-Approchant";
                        } else {
                            elt.list += "-Exact";
                        }
                    }
                    delete elt.exclu;
                    delete elt.orange;
                }
                elt.dimension74 = "classique";
                for (const key in fors[i].data) {
                    if (elt[key]) {
                        elt[key] = fors[i].data[key];
                    }
                }
                ev.ecommerce.impressions.push(elt);
            }
          new GlobalEvent(ev, undefined);   
        }
        this.tracking = false;
        this.displayed = [];
        for (let i = 0; i < this.waiting.length; i++) {
            this.displayed.push(this.waiting[i]);
        }
        this.waiting = [];
        if (this.displayed.length) {
            this.waitTrack();
        }
    }

}

class DataForClick {
    alreadyDisplayed = false;
    element: HTMLElement;
    linked:any;
    data: any;

    constructor(element:HTMLElement, linked:any, data:any) {
         this.element = element;
        this.linked = linked;
        this.data = data;
        this.init();
    }
   
    init() {
        DataForClickBundle.prototype._register(this);
        onDisplay(this.element, () => {
          PubSub.publish("dataforclick-displayed", this);
        });
       
    }

}

export default class ForTrigger extends Component {
    modalOpened = false;
    oldClick: any;
    clinstance: any;
    linked: any;
    props: any;

    constructor(props: any, element:HTMLElement){
        super(props, element)
        this.props = props;
        if(!this.props.for) {
          this.props.for = this.props.value;
        }
    }
    mounted() {
        if(this.props && this.props.for) {
            const elt = document.getElementById(this.props.for);
            this.linked = elt;
            if(this.props.click) {
                new DataForClick(this.element, elt, this.props.click);
                this.oldClick = elt.getAttribute("data-click");
     
                // Retrieve dataClick instance 
                this.clinstance = getSingleInstanceByElement("ClickEvent", this.linked);
            }

            this.init()
        }   
    }
    init() {

        const stoppers: any[] = [];
        let exist = false;
        const stoppersAttr = ["[data-link]", "[data-bookmark]", "[data-l]", "a", "[data-job-timetravel_trigger]", "label[for]"];

        for (let j = 0; j < stoppersAttr.length; j++) {
          exist = false;
          const stoups = this.element.querySelectorAll(stoppersAttr[j]);

          for (let z = 0; z < stoups.length; z++) {
            for (let k = 0; k < j; k++) {
              if (
                stoups[z].hasAttribute(stoppersAttr[k].replace(/[[\]]/g, ""))
              ) {
                exist = true;
              }
            }
            if (!exist) {
              stoppers.push(stoups[z]);
            }
          }
        }
        const modals = this.element.querySelectorAll("[data-modal]");
        for (let m = 0; m < modals.length && !this.modalOpened; m++) {
          this.modalOpened = (<HTMLInputElement>modals[m]).checked;
        }

        this.element.addEventListener("click", (event) => {
            if(this.element.hasAttribute("data-offer-extract")) {
                window.history.pushState({}, "", "#"+this.element.getAttribute("id"));
            }
            if (event.which != 2) {
                let trig = true;
                for (let i = 0; i < stoppers.length && trig; i++) {
                  trig = !isEventOn(event, stoppers[i]);
                }
                 for (let i = 0; i < modals.length && trig; i++) {
                   trig = !(<HTMLInputElement>modals[i]).checked;
                   if (!trig) {
                     this.modalOpened = true;
                   }
                 }
                 if (trig) {
                   if (this.modalOpened) {
                     this.modalOpened = false;
                   } else {
                     if (trig) {
                       if (event.ctrlKey) {
                         window.open(this.linked.href, "_blank");
                       } else {
                         if (this.clinstance && this.clinstance.update) {
                            try {
                           this.clinstance.update(this.props.click);
                            } catch(e) {
                              //ras
                            }
                         }
                         this.linked?.click();
                         if (this.clinstance && this.oldClick) {
                           try {
                             this.clinstance.update(JSON.parse(this.oldClick));
                           } catch (e) {
                             // ras
                           }
                         }
                       }
                     }
                   }
                 }


            }
        })

        this.element.addEventListener("mousedown", (event) => {
                if (event.which == 2) {
                    let trig = true;
                    for (let i = 0; i < stoppers.length && trig; i++) {
                        trig = !isEventOn(event, stoppers[i]);
                    }
                    for (let i = 0; i < modals.length && trig; i++) {
                        trig = !(<HTMLInputElement>modals[i]).checked;
                        if (!trig) {
                            this.modalOpened = true;
                        }
                    }
                    if (trig) {
                        if (this.modalOpened) {
                            this.modalOpened = false;
                        } else {
                            if (trig) {
                                window.open(this.linked.href, '_blank');
                            }
                        }

                    }
            }
        });
    }

}